import { Navigate, PathRouteProps, Route } from "react-router";

import { BomByComponent } from "../job-tracking/components/bom-by-component/BomByComponent";
import { BomHierarchy } from "../job-tracking/components/bom-hierarchy/BomHierarchy";
import { EstimateDetails } from "./components/estimate-details/EstimateDetails";
import { EstimateTrackerLayout } from "./EstimateTrackerLayout";
import { withEstimateTrackingData } from "./components/withEstimateTrackingData";

export type EstimateTrackerPath = "details" | "bom-hierarchy" | "bom-by-component";

/** A copy of `<Route/>` from `react-router`, with the props restricted to only accept paths in the `JobTrackerPath` type */
const EstimateTrackerRoute: React.FC<Omit<PathRouteProps, "path"> & { path: EstimateTrackerPath }> = Route;

export const estimateTrackerRoutes = (
  <Route path="estimate/:estimateNumber" element={<EstimateTrackerLayout />}>
    <Route index element={<Navigate to={"./details"} />} />
    <EstimateTrackerRoute path="details" element={<EstimateDetails />} />
    <EstimateTrackerRoute
      path="bom-hierarchy"
      Component={withEstimateTrackingData(({ bomHierarchy }) => (
        <BomHierarchy bomHierarchy={bomHierarchy} />
      ))}
    />
    <EstimateTrackerRoute
      path="bom-by-component"
      Component={withEstimateTrackingData(({ bomComponents }) => (
        <BomByComponent bomComponents={bomComponents} jobId={null} />
      ))}
    />
  </Route>
);

export const pageTitleForEstimateTrackerPath: Record<EstimateTrackerPath, string> = {
  details: "Estimate Details",
  "bom-hierarchy": "BOM Hierarchy",
  "bom-by-component": "BOM By Component",
};
